import CirgsCustomerStatusChip from './CirgsCustomerStatusChip';

export default CirgsCustomerStatusChip;
